import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API, getAvailability } from "../lib/api";

export default function GuideThanksPage() {
  const [availability, setAvailability] = useState({ lead_magnet_available: false });
  const name = localStorage.getItem("wespik.guide.name") || "";

  const loadAvailability = useCallback(() => {
    getAvailability().then(setAvailability).catch(() => undefined);
  }, []);

  useEffect(() => {
    loadAvailability();
  }, [loadAvailability]);

  return (
    <main className="max-w-[860px] mx-auto px-6 py-24">
      <div className="wk-eyebrow mb-5">Guía gratuita</div>
      <h1 className="text-[42px] lg:text-[56px] font-extrabold tracking-hero leading-[1.05]" style={{ color: "#1E1924" }} data-testid="guide-thanks-title">
        Listo, {name}. Aquí tienes tu guía.
      </h1>
      <div className="mt-10 flex flex-wrap gap-3">
        {availability.lead_magnet_available ? (
          <a className="wk-btn wk-btn-primary" href={`${API}/lead-magnet`} data-testid="guide-download-button">
            Descargar la guía
          </a>
        ) : (
          <button className="wk-btn wk-btn-primary" disabled data-testid="guide-download-unavailable-button">
            Disponible muy pronto
          </button>
        )}
        <Link className="wk-btn wk-btn-ghost" to="/reservar" data-testid="guide-booking-button">
          Reservar mi primera sesión · $22
        </Link>
      </div>
    </main>
  );
}